module.exports = __webpack_public_path__ + "img/home_icon.5f602390.svg";